// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import LaptopOutlinedSvg from "@fishx/icons-svg/es/asn/LaptopOutlined";
import FishxIcon from '../components/FishxIcon';

var LaptopOutlined = function LaptopOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: LaptopOutlinedSvg
  }));
};

LaptopOutlined.displayName = 'LaptopOutlined';
export default React.forwardRef(LaptopOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/LaptopOutlined.js
// module id = 3005
// module chunks = 0